<div class="row heading-container">
  <div class="column">
    <span><mat-icon *ngIf="icon" [fontIcon]="icon"></mat-icon> {{title}}</span>
  </div>
</div>
